import cn from "classnames";
import React from "react";
import { Icon } from "~/components/IconButton/IconButton";
import IconButton from "~/components/IconButton/index";
import styles from "~/components/ProjectBasedActivation/styles.module.less";

interface HelpPanelProps {
    image: string;
    altImageText?: string;
    content: React.ReactNode;
    className?: string;
    onClose: () => void;
}

function HelpPanel({ image, altImageText, content, className, onClose }: HelpPanelProps) {
    return (
        <div className={cn(styles.helpPanel, className)}>
            <span className={styles.helpPanelBtn}>
                <IconButton toolTipContent={"Collapse help"} onClick={() => onClose()} icon={Icon.ChevronIcon} />
            </span>
            <img src={image} className={styles.helpPanelImage} alt={altImageText} />
            <div className={styles.helpPanelText}>{content}</div>
        </div>
    );
}

export default HelpPanel;
